// extracted by mini-css-extract-plugin
export var actionText = "_rd-4";
export var container = "_rd-0";
export var leftSection = "_rd-1";
export var rightSection = "_rd-2";
export var settingsButton = "_rd-6";
export var settingsIcon = "_rd-7";
export var shortcut = "_rd-5";
export var shortcutGroup = "_rd-3";